import { TrackingService } from 'sharebase/services/trackingService';

export let TrackClickDirective = function($timeout:ng.ITimeoutService, sbTrackingService:TrackingService): ng.IDirective {
    return {
        restrict: 'A',
        link: ($scope, element, attrs) => {  
            if(!angular.isDefined(attrs.sbTrackClickAction)){
                throw new Error('Must supply a click action to be tracked.');
            }

            let action = attrs.sbTrackClickAction;
            let location = attrs.sbTrackClickLocation;

            //Directives like md-list-item remove all click event handlers, so added the timeout to get around that
            $timeout(() => element.on('click', click));
            
            function click() {
                sbTrackingService.trackClick(action, location);
            }

            $scope.$on('$destroy', () => element.off('click', click));
        }
    };
}
TrackClickDirective.$inject = [
    '$timeout',
    'sbTrackingService'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/trackClick/trackClick.ts